<div class="padding-y-2">
    <app-document-status-badge class="right floated" [document]="document"></app-document-status-badge>

    <p class="flex">
        <strong>{{ translationKey('title') | translate }}</strong
        ><ui-info class="margin-left-1" [text]="translationKey('tooltip')"></ui-info>
    </p>

    <p>{{ translationKey('criteria') | translate }}</p>

    <p *ngIf="document.rejectionReason" class="text-color-error">
        {{ 'payroll.setup.rejectionReason' | translate: { reason: document.rejectionReason } }}
    </p>

    @if (!readOnly && ['new', 'rejected'].includes(document.state)) {
        <ui-button type="outline" (click)="getFile()">
            {{ 'payroll.setup.upload' | translate }}
        </ui-button>
    }

    <p *ngIf="['ready_for_review', 'verified'].includes(document.state)">
        <i>{{ 'payroll.setup.fileUploadedOn' | translate: { date: document.createdAt | date } }}</i>
    </p>
</div>
